import React from "react";

export default function NotFound() {
  return (
    <div className="text-center">
      <h3>Sorry, page not found!</h3>
    </div>
  );
}